import { Link } from 'react-router-dom';

export default function CtaBanner() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20organic%20flowing%20shapes%20background%20with%20warm%20terracotta%20coral%20and%20sand%20cream%20tones%2C%20subtle%20gradient%20texture%2C%20minimalist%20modern%20design%20aesthetic%2C%20soft%20flowing%20forms%20and%20subtle%20patterns%2C%20no%20text%2C%20elegant%20clean%20backdrop%20suitable%20for%20fashion%20brand&width=1600&height=600&seq=cta-v2-2026-c3&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-500/90 via-primary-500/80 to-accent-500/70"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-semibold text-white mb-4">
          Ready to Explore the Basetao Spreadsheet?
        </h2>
        <p className="text-sm md:text-base text-white/80 max-w-lg mx-auto mb-8">
          Browse all 14 product categories on our main website and start discovering amazing finds today.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-6 py-3 text-sm font-semibold text-foreground-950 bg-white hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
          >
            Basetao Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-6 py-3 text-sm font-semibold text-white border-2 border-white/40 hover:border-white/70 rounded-lg transition-colors whitespace-nowrap"
          >
            Buy It Now
          </a>
        </div>
        <div className="mt-6">
          <Link
            to="/article/basetao-spreadsheet-guide"
            className="inline-flex items-center gap-1.5 text-sm text-white/70 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-article-line"></i>
            Read Our In-Depth Basetao Spreadsheet Guide
          </Link>
        </div>
      </div>
    </section>
  );
}